import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\components\\public-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "D:\\b\\baczonedz\\src\\components\\ui\\site-footer.tsx");
